<template>
    <div>
        <!--快捷注册第二步-->
        <Modal v-model="modalStatus" width="400" :mask-closable="false">
            <div slot="close" class="close-btn">
                <Icon type="close-round" @click="modalStatus == false" color="#5c6b77" size="15"></Icon>
            </div>
            <div class="login-header">设置密码</div>
            <Form ref="registerTwoForm" :model="params" :rules="rule">
                <Row>
                    <FormItem prop="password">
                        <Input v-model.trim="params.password" placeholder="密码由 4-16位字母、数字、特殊符号线组成"></Input>
                    </FormItem>
                </Row>
                <Row>
                    <FormItem prop="rePassword">
                        <Input v-model.trim="params.rePassword" placeholder="确认密码由 4-16位字母、数字、特殊符号线组成"></Input>
                    </FormItem>
                </Row>
            </Form>
            <div slot="footer">
                <Button type="primary" @click="handleRegister" class="login-btn" long>注册并登录</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
    export default {
        data() {
            //校验密码
            const validatePass = (rule, value, callback) => {
                let reg = /([A-Za-z]|[0-9]|-|_){4,16}/;
                if (value === "") {
                    callback(new Error("密码不可为空"));
                } else if (reg.test(value) === false) {
                    callback(
                        new Error("新密码必须由 4-16位字母、数字、特殊符号线组成")
                    );
                } else {
                    // if (this.registerTwo.params.password !== '') {
                    //     this.$refs.formValidate.validateField('registerTwo.rule.rePassword');
                    // }
                    callback();
                }
            };
            //校验重复密码
            const validatePassCheck = (rule, value, callback) => {
                if (value === "") {
                    callback(new Error("确认密码不可为空"));
                } else if (value !== this.params.password) {
                    callback(new Error("两次密码不一致"));
                } else {
                    callback();
                }
            };

            return {
                //注册信息
                params: {
                    password: "",
                    rePassword: "",
                },
                //注册校验
                rule: {
                    password: [{
                        required: true,
                        validator: validatePass,
                        trigger: "blur",
                    }, ],
                    rePassword: [{
                        required: true,
                        validator: validatePassCheck,
                        trigger: "blur",
                    }, ],
                },
                //register模态框
                modalStatus: false,
            }
        },
        methods: {
            handleRegister() {
                this.$emit("handleRegister", this.params.password)
            }
        },
    }
</script>
<style scoped>
    .login-header {
        height: 98px;
        line-height: 98px;
        text-align: center;
        font-size: 20px;
        font-weight: bold;
        color: #333;
    }
</style>


// WEBPACK FOOTER //
// src/components/ModalTwoReg.vue